import { render } from "./mynewchart.vue?vue&type=template&id=61e1d45d&scoped=true"
import script from "./mynewchart.vue?vue&type=script&lang=js"
export * from "./mynewchart.vue?vue&type=script&lang=js"

import "./mynewchart.vue?vue&type=style&index=0&id=61e1d45d&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\mcc_ssd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e1d45d"]])

export default __exports__